export default "__VITE_ASSET__yiJZAQ8D__"